import { requestGlossaryTerms } from '../../request/backendApi/glossary/getGlossaryTerms';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';
import { tagged } from '@vs-shop/engine/data/util/tagged';

type FetchGlossaryTermsKey = {
  readonly _tag: 'FetchGlossaryTermsKey';
  readonly alphabetFilter: string | null;
  readonly nameFilter: string | null;
  readonly onlyFavorites: boolean;
  readonly page: number;
  readonly itemsPerPage: number;
};

// v4 dropped `Data.tagged`; the engine's `tagged` keeps the Equal-based
// structural equality `Atom.family` memoization relies on.
const FetchGlossaryTermsKey = tagged<FetchGlossaryTermsKey>('FetchGlossaryTermsKey');

const fetchGlossaryTermsAtomFamily = Atom.family((key: FetchGlossaryTermsKey) =>
  RuntimeClientAtom.atom(
    requestGlossaryTerms(
      key.alphabetFilter,
      key.nameFilter,
      key.onlyFavorites,
      key.page,
      key.itemsPerPage
    )
  ).pipe(Atom.keepAlive)
);

export const fetchGlossaryTermsAtom = (
  alphabetFilter: string | null,
  nameFilter: string | null,
  onlyFavorites: boolean,
  page: number,
  itemsPerPage: number
) =>
  fetchGlossaryTermsAtomFamily(
    FetchGlossaryTermsKey({ alphabetFilter, nameFilter, onlyFavorites, page, itemsPerPage })
  );
